import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46177ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tab" }

import { ref } from "vue";
import { useStore } from "@/store";
import Tabs from "@/components/Tabs.vue";
import TabTutorial from "@/components/TabTutorial.vue";
import TabMessengerRNA from "@/components/TabMessengerRNA.vue";
import TabProtein from "@/components/TabProtein.vue";
import TabQuestions from "@/components/TabQuestions.vue";
import TabLoad from "@/components/TabLoad.vue";
import { MessagesAddresses } from "@/messages";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const { run, stop } = store;
const activeTab = ref<MessagesAddresses>("tabs.tutorial");
const tabItems: MessagesAddresses[] = [
  "tabs.tutorial",
  "tabs.protein",
  "tabs.rna",
  "tabs.questions",
  "tabs.load",
];

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: tabItems,
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "tab-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(run) && _unref(run)(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: _unref(store).isRunning ? 'rotate-left' : 'play'
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(!_unref(store).isRunning ? _unref(t)("view.run") : ""), 1)
        ]),
        (_unref(store).isRunning)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tab-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(stop) && _unref(stop)(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "stop" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("view.stop")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(TabTutorial, null, null, 512), [
        [_vShow, activeTab.value === 'tabs.tutorial']
      ]),
      (activeTab.value === 'tabs.rna')
        ? (_openBlock(), _createBlock(TabMessengerRNA, { key: 0 }))
        : _createCommentVNode("", true),
      (activeTab.value === 'tabs.protein')
        ? (_openBlock(), _createBlock(TabProtein, { key: 1 }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(TabQuestions, null, null, 512), [
        [_vShow, activeTab.value === 'tabs.questions']
      ]),
      (activeTab.value === 'tabs.load')
        ? (_openBlock(), _createBlock(TabLoad, { key: 2 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})